export const customersSelectGrowthProfiling: any = {
	allCustomers: "ALL",
	identCustomers: "IDENTIFIED",
}

export const channelsSelectGrowthProfiling: any = {
	channels: "ALL",
	stores: "STORES",
	ecommerce: "ECOMMERCE",
}

export const noDataError = {
	name: "phronesis.error.nodata.title",
	message: "phronesis.error.nodata.message",
}

export const validateValuePercentage = (
	percentage: number,
	moreThanOne: string,
	lessThanOne: string
): string => {
	if (percentage * 100 < 1) {
		return lessThanOne
	}
	return moreThanOne
}
export const removeSpaces = (value: string) => {
	return value.toLowerCase().replace(/\s/g, "")
}

export const gender = ["Female", "Male", "No data"]
export const channel = ["Both"]
